module.exports = __webpack_public_path__ + "img/Recurso 24@300xt.bef6c57f.webp";